import { PostRequest, replaceWithCurrentApiVersion } from "../../utils/api";
import { Notification } from "../../components/notification/notification";

export const refineApiWithUrlParams = (endpoint: string, urlparams: Map<string, string>) => {
  if (endpoint.length > 0 && urlparams.size > 0) {
    urlparams.forEach((value, key) => {
      endpoint = endpoint?.replace("{" + key + "}", value);
    });
  }

  return endpoint;
}


export const saveRecordAsDraft: any = async (recordId: string, payload: any, args: any[], urlparams: Map<string, string>) => {

  let endpoint = args[0] + `/${args[1]}`;
  endpoint = refineApiWithUrlParams(endpoint, urlparams);
  try {
    await PostRequest(replaceWithCurrentApiVersion(endpoint), payload);
    Notification("success", "Successfuly saved as draft.");
    return { message: "Successfuly saved as draft. ", status: "SUCCESS" };
  } catch (err: any) {
    Notification("error", err?.response?.data?.message ?? "Something went wrong, please check with admin.");
    return { message: "Something went wrong, please check with admin.", status: "ERROR" };
  }
}
